export default "__VITE_ASSET__Daz$farK__"